// src/Success.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { functions } from "./firebase";
import { httpsCallable } from "firebase/functions";
import './Success.css';

export default function Success() {
   const navigate = useNavigate();
   const [loading, setLoading] = useState(true);
   const [succeeded, setSucceeded] = useState(false);

   useEffect(() => {
     const executeReservation = async () => {
       try {
         // 1️⃣ Récupérer session_id et uid depuis l'URL
         const params = new URLSearchParams(window.location.search);
         const sessionId = params.get("session_id");
         const userId = params.get("uid");

         if (!sessionId || !userId) {
           alert("Données de paiement manquantes");
           setLoading(false);
           navigate("/");
           return;
         }

         // 2️⃣ Appeler le backend pour finaliser la commande sécurisée
         const finalizeFn = httpsCallable(functions, "finalizeStripeOrder");
         const result = await finalizeFn({ userId, sessionId });

         if (result.data && result.data.success) {
           setLoading(false);
           setSucceeded(true);
         } else {
           throw new Error(result.data?.message || "Erreur de finalisation côté serveur.");
         }
       } catch (error) {
         console.error("Erreur post-paiement:", error);
         setLoading(false);
         alert("❌ Erreur lors de la finalisation de la commande : " + error.message);
         navigate("/"); 
       }
     };

     executeReservation();
   }, [navigate]);

   if (loading) {
     return (
       <div className="success-page">
         <div className="success-content">
           <h2>Merci pour votre paiement !</h2>
           <p>Votre commande est en cours de finalisation...</p>
           <div className="loader"></div>
         </div>
       </div>
     );
   }

   if (succeeded) {
     return (
       <div className="success-page">
         <div className="success-content">
           <h2>✅ Merci pour votre paiement !</h2>
           <p>Votre commande a été validée avec succès.<br/>Un mail de confirmation vous a été envoyé.</p>
           <button className="success-home-btn" onClick={() => navigate("/")}>Retour à l'accueil</button>
         </div>
       </div>
     );
   }

   return (
     <div className="success-page">
       <div className="success-content">
         <h2>Erreur</h2>
         <p>Une erreur est survenue lors de la finalisation de votre commande.</p>
       </div>
     </div>
   );
}